import type {TransportAssocEntity} from '@ots-frontend/ots-data';
import {ComplianceWorkspace} from '@ots-frontend/ots-ui-tw';

export type TicketComplianceProps = {ticket: TransportAssocEntity};

/** Both React ticket profiles and WaterGo now use the same agency-extensible workspace. */
export const TicketCompliance = ({ticket}: TicketComplianceProps) =>
  <ComplianceWorkspace subject={{kind: 'ticket', id: ticket.id, tenantCode: ticket.database}}
    revision={ticket.lastModifiedDttm}
    subjectLabel={`Ticket ${ticket.resourceIdentifiers?.join(', ') || ticket.id}`}/>;
